import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-up-down-24", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { d: "M11 10L7 6l-4 4m4-2.5v10.75M13 14l4 4 4-4m-4 2.5V5.75", fill: "none", strokeLinecap: "round", strokeLinejoin: "round", stroke: "currentColor", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
